import { MessageCircle, Phone, MapPin, Instagram, Mail } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { BRAND, LOGO_URL } from "@/lib/constants";

const Contact = () => {
  const { t } = useLanguage();
  return (
    <section id="contact" className="relative py-20 md:py-28" data-testid="contact-section">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative rounded-3xl border border-white/10 overflow-hidden bg-gradient-to-br from-[#1a0606] via-[#0f0f0f] to-[#0a0a0a] p-8 md:p-14 text-center">
          <div className="absolute -left-24 -top-24 w-72 h-72 rounded-full bg-[#e10600]/15 blur-3xl pointer-events-none" />
          <div className="absolute -right-24 -bottom-24 w-72 h-72 rounded-full bg-[#e10600]/10 blur-3xl pointer-events-none" />

          <div className="relative flex flex-col items-center">
            <span className="bg-white rounded-2xl px-4 py-2 inline-flex items-center mb-8">
              <img src={LOGO_URL} alt="Dent Xpress" className="h-12 w-auto" />
            </span>

            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-white/10 bg-white/5 text-[11px] tracking-[0.25em] uppercase font-display text-white/70">
              <span className="w-1.5 h-1.5 rounded-full bg-[#e10600]" />
              {t.contact.eyebrow}
            </div>
            <h2 className="mt-4 font-display font-black text-3xl md:text-5xl tracking-tight">
              {t.contact.title}
            </h2>
            <p className="mt-4 text-white/65 max-w-2xl">{t.contact.subtitle}</p>

            <div className="mt-8 flex flex-wrap justify-center gap-3">
              <a
                href={BRAND.whatsappLink}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 px-6 py-4 rounded-full bg-[#e10600] hover:bg-[#c20500] text-white font-bold transition shadow-xl shadow-red-900/40"
                data-testid="contact-whatsapp-btn"
              >
                <MessageCircle className="w-5 h-5" />
                {t.common.whatsapp} — {BRAND.whatsappNumberLocal}
              </a>
              <a
                href={BRAND.telLink}
                className="inline-flex items-center gap-2 px-6 py-4 rounded-full border border-white/20 hover:bg-white/5 text-white font-bold transition"
                data-testid="contact-call-btn"
              >
                <Phone className="w-5 h-5" />
                {t.common.callNow} — {BRAND.phone}
              </a>
              <a
                href={BRAND.shopTelLink}
                className="inline-flex items-center gap-2 px-6 py-4 rounded-full border border-white/20 hover:bg-white/5 text-white font-bold transition"
                data-testid="contact-shop-call-btn"
              >
                <Phone className="w-5 h-5" />
                {t.contact.shopLabel} — 24837666
              </a>
              <a
                href={BRAND.mapsLink}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 px-6 py-4 rounded-full border border-white/10 hover:border-white/25 text-white/85 hover:text-white font-bold transition"
                data-testid="contact-maps-btn"
              >
                <MapPin className="w-5 h-5" />
                {t.common.getDirections}
              </a>
              <a
                href={BRAND.emailLink}
                className="inline-flex items-center gap-2 px-6 py-4 rounded-full border border-white/10 hover:border-white/25 text-white/85 hover:text-white font-bold transition"
                data-testid="contact-email-btn"
              >
                <Mail className="w-5 h-5" />
                {BRAND.email}
              </a>
              <a
                href={BRAND.instagramLink}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 px-6 py-4 rounded-full border border-white/10 hover:border-white/25 text-white/85 hover:text-white font-bold transition"
                data-testid="contact-instagram-btn"
              >
                <Instagram className="w-5 h-5" />
                {BRAND.instagramHandle}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
